export const BASE_URL = "https://foodxplorer.onrender.com";